import * as React from 'react'
import { graphql } from 'gatsby'
import { mediaType } from './mapper'
import Wrapper from '../../ui/wrapper'
import { ModalWithMedias } from '../../ui/medias/ModalWithMedia'

type FirmMainMediaProps = {
  mainMedia: mediaType
  name: string | null
  youTubeApiKey: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  otherMedias?: any[]
}

const MainMedia: React.FC<FirmMainMediaProps> = ({
  mainMedia,
  name,
  youTubeApiKey,
  otherMedias = [],
}) => (
  <Wrapper noBorder>
    {mainMedia && (
      <ModalWithMedias
        id={mainMedia.id as string}
        media={mainMedia.media}
        name={name ?? ''}
        video={mainMedia?.video}
        youTubeApiKey={youTubeApiKey}
        otherMedias={otherMedias}
      />
    )}
  </Wrapper>
)

export default MainMedia

export const query = graphql`
  fragment FirmMedias on STRAPI_ACCOUNTING_FIRM {
    medias {
      url
      id
      local {
        url
        width
        height
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  }
`
